export default __webpack_public_path__ + "static/media/cyw.2bfac606.mp4";